/**
 * A case card's court and age lines (proposal 5): "Their court · Jake
 * Butchko · asked 2d ago · reminder Mon, Oct 12" (or "Our court" / "Ready to
 * close"), anyone else an ask is open with, and "Opened Sep 30 · 9 days".
 * Read-only text; the court comes from the server.
 */
import type { DoorInvestigationRead } from '../../services/qcpInvestigations';
import {
  courtLine,
  courtReasonLine,
  openedLine,
  unaskedItemsLine,
} from '../../components/portal/caseCourtView';
import styles from './CaseCourtLines.module.css';

export default function CaseCourtLines({
  investigation,
  waitingOn = [],
  now,
}: {
  investigation: DoorInvestigationRead;
  /** Everyone with an open ask on the case, oldest first. */
  waitingOn?: string[];
  now?: Date;
}) {
  const { court } = investigation;
  const others = waitingOn.filter((name) => name !== court.person);
  const unasked = unaskedItemsLine(investigation);
  const reason = courtReasonLine(court);
  return (
    <>
      <span className={styles.court} data-side={court.side} data-testid="case-court">
        {courtLine(court, now)}
      </span>
      {reason && (
        <span className={styles.reason} data-testid="case-court-reason">
          {reason}
        </span>
      )}
      {unasked && (
        <span className={styles.also} data-testid="case-court-unasked">
          {unasked}
        </span>
      )}
      {court.side === 'theirs' && others.length > 0 && (
        <span className={styles.also}>Also waiting on {others.join(', ')}</span>
      )}
      <span className={styles.age} data-testid="case-age">
        {openedLine(investigation, now)}
      </span>
    </>
  );
}
